var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFashionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.43604L12 6.43604L9 4.43604C8.41425 4.94545 7.07071 5.72947 7.00348 6.58169C6.97434 6.95116 7.12883 7.15319 7.43782 7.55726C8.11164 8.43843 8.87991 8.95612 8.87991 10.436H15.1201C15.1201 8.95612 15.8884 8.43843 16.5622 7.55726C16.8712 7.15319 17.0257 6.95116 16.9965 6.58169C16.9293 5.72947 15.5858 4.94545 15 4.43604Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8632 18.2442C19.1589 15.5539 17.3658 13.0862 16.1811 11.6729C15.3314 10.6592 14.7041 10.436 13.3704 10.436H10.6296C9.29591 10.436 8.66864 10.6592 7.81893 11.6729C6.63423 13.0862 4.8411 15.5539 4.13677 18.2442C3.70683 19.8865 4.29064 20.7853 5.88646 21.3661C7.32124 21.8883 9.43708 22.436 12 22.436C14.5629 22.436 16.6788 21.8883 18.1135 21.3661C19.7094 20.7853 20.2932 19.8865 19.8632 18.2442Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.43604V2.43604",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.43604V2.43604",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.436C14 15.436 16 18.436 16 21.936M10 15.436C10 15.436 8 18.436 8 21.936",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashionIcon);
export default __webpack_public_path__ + "static/media/fashion-icon.2c83c4a2056498791d1bc95fcfb34015.svg";
export { ForwardRef as ReactComponent };